import { render, staticRenderFns } from "./WorkingUnsolvedImportSettle.vue?vue&type=template&id=2c1c4c44"
import script from "./WorkingUnsolvedImportSettle.vue?vue&type=script&lang=js"
export * from "./WorkingUnsolvedImportSettle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c1c4c44')) {
      api.createRecord('2c1c4c44', component.options)
    } else {
      api.reload('2c1c4c44', component.options)
    }
    module.hot.accept("./WorkingUnsolvedImportSettle.vue?vue&type=template&id=2c1c4c44", function () {
      api.rerender('2c1c4c44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/WorkingUnsolvedImportSettle.vue"
export default component.exports